/**
 * Every clinician owns a copy of every committed fixture, and all copies of one
 * fixture carry identical demographics — same name, date of birth, address,
 * phone and member id — so the chart itself cannot tell two of them apart. The
 * tag is the only thing on screen that does.
 *
 * It is taken from the trailing characters, not the leading ones. Copies are
 * minted with `uuid7`, which is timestamp-ordered, and a clinician's whole
 * roster is claimed in a single batch, so copies seeded in the same second
 * agree well past a git-style eight-character prefix. Two real sandbox copies
 * read `06ab31a2-7b19…` and `06ab31a2-7958…`; a leading prefix would render
 * them identically and reproduce the exact confusion this tag exists to end.
 */
const TAG_LENGTH = 6;

export function formatDemoCopyTag(patientUserId: string): string {
  return patientUserId.replaceAll('-', '').slice(-TAG_LENGTH);
}
